<app-base-page-template>
  <app-base-page-content-template>
    <app-business-service-requests-grid
      [businessKey]="businessKey"
      (rowClick)="onRowClicked($event)">
    </app-business-service-requests-grid>
  </app-base-page-content-template>
</app-base-page-template>
